import { Ref, ref } from 'vue'
import { defineStore } from 'pinia'
import { useEzioAPI, useEzioWs } from '@ezio/services'
import { ScaOperation } from './types'
import { localStores } from '../index'
import { scaModalBox } from '.'
import { useCardsStore } from '@ezio/features/cards/store'
import { useBankStore } from '@ezio/features/bank/store'
import { usePayoutsStore } from '@ezio/features/payouts/store'

export const useScaStore = defineStore('sca', () => {
    const { api } = useEzioAPI()

    const all: Ref<{ [id: string]: ScaOperation }> = ref({})

    const init = async () => {
        const { ws } = useEzioWs()

        ws.on('sca_operation:create', async (payload: any) => {
            console.log('sca_operation create', payload)

            const response = await fetchOperation(payload.sca_operation_id)
            if (import.meta.env.APP_NAME === 'manager') {
                scaModalBox.show(response.id)
            }
        })

        ws.on('sca_operation:update', async (payload: any) => {
            console.log('sca_operation update', payload)

            const response = await fetchOperation(payload.sca_operation_id)

            if (import.meta.env.APP_NAME === 'manager') {
                if (response.status === 'validated') {
                    handleValidatedOperation(response)
                }
            }
        })

        const operations = await fetchOperationsCollection()
        if (import.meta.env.APP_NAME === 'manager') {
            if (operations[0]) {
                scaModalBox.show(operations[0].id)
            }
        }
    }

    const handleValidatedOperation = (operation: ScaOperation) => {
        if (operation.scaType === 'session') {
            localStores.currentStore.fetch()
            if (operation.action === 'statement' || operation.action === 'account_details') {
                useBankStore().handleValidatedScaOperation(operation)
            }
        } else {
            if (operation.objectType === 'Beneficiary') {
                console.log('after beneficiary')
                usePayoutsStore().handleValidatedScaOperation(operation)
            }
            if (operation.objectType === 'Card') {
                useCardsStore().handleValidatedScaOperation(operation)
            }
        }
    }

    const createWeakSession = async (token: string) => {
        const response = await api.post('sca_operations', {
            token
        })
    }

    const fetchOperationsCollection = async (): Promise<ScaOperation[]> => {
        try {
            const response = await api.get('sca_operations')
            store(response.data)
            return response.data
        } catch (e) {
            return []
        }
    }
    const fetchOperation = async (id: string): Promise<ScaOperation> => {
        const response = await api.get('sca_operations/' + id)
        store([response.data])
        return response.data
    }

    const updateOperation = async (data: ScaOperation) => {
        const response = await api.put('sca_operations/' + data.id, data)
        store([response.data])
        return response.data
    }

    const fetchWallet = async (userId: string) => {}
    const refreshWallet = async (agencyId: string, userId: string) => {
        const response = await api.post('agencies/' + agencyId + '/users/' + userId + '/sca_wallet')
        await localStores.currentStore.fetch()
    }
    const lockWallet = async (userId: string) => {}
    const unlockWallet = async (userId: string) => {}
    const resetWalletPin = async (userId: string) => {}
    const deleteWallet = async (userId: string) => {}

    const store = (clients: ScaOperation[]) => {
        all.value = Object.assign({}, all.value, objectify(clients))
    }

    const reset = () => {
        all.value = {}
    }

    return {
        init,
        all,
        createWeakSession,
        fetchOperationsCollection,
        fetchOperation,
        updateOperation,
        refreshWallet,
        store,
        reset
    }
})

export const objectify = (data: any[], toAdd: any = null): { [id: string]: any } => {
    const o: any = {}
    data.forEach((d) => {
        const n = Object.assign({}, d, toAdd)
        o[d.id] = n
    })
    return o
}
